<template>
    <v-container>

        <!-- <NavBar :step="7" /> -->

        <Titulo></Titulo>

        <br>
        <br>

        <div class="text-center">

            <p class="text-center" style=" font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 18px; line-height: 25px;
                letter-spacing: -0.01em; color: #2D387C; text-transform:uppercase;">¡Listo {{ capitalizeName(userData.name) }}!
            </p>

            <p class="text-center" style=" font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 20px; line-height: 25px;
                letter-spacing: -0.01em; color: #2D387C; ">A continuación podrás descargar tu
                póliza de seguro oncológico.
            </p>

            <label class="text-center subLabel">También la recibirás en tu correo.</label>

            <br>

            <label class="text-center subLabel">Gracias por confiar en nosotros.</label>   

                <br>
                <br>
                <br>

                <label class="text-center subLabel">¿Te gustaría contratar este seguro para alguien más?</label>

                <br>
                <br>
                <div class="text-center">
                    <v-btn v-if="screen > 800" class="botonUse" elevation="0" @click="returnPage(0)">
                    Volver a contratar
                    </v-btn>
                </div>

                <div class="text-center">
                    <v-btn v-if="screen < 800" class="botonUse" elevation="0" @click="returnPage(0)">
                    Volver a contratar
                    </v-btn>
                </div>

                <br>
                <br>
                <div style="max-width: 400px; margin: auto;">

                    <label class="text-center subLabelSub">Si no recibiste tu póliza en tu correo, recuerda revisar en la
                    bandeja de spam, promociones y no deseados. </label>


                </div>
                <br>

            </div>

            <div class="text-center footerFinish">

                <div style="background-color: #E3E9FD; min-height: 150px;">

                <br>

                <div v-if="screen > 800"
                    style="background-color: #E3E9FD; min-height: 150px; display: flex; justify-content: center; align-items: center;">

                    <div style="max-width: 250px; margin: auto; margin-left: 25%;">

                    <label class="text-center subLabelSub">¿Quieres ver otros seguros? Conócelos en nuestro sitio web. </label>

                    <br>
                    <br>

                    <v-btn class="botonUse2" elevation="0" @click="returnPage(1)">
                        Volver al inicio
                    </v-btn>

                    </div>

                    <div style="max-width: 250px; margin: auto; margin-right: 25%;">

                    <label class="text-center subLabelSub">Si tienes problemas, comunícate con nosotros aquí: </label>

                    <br>
                    <br>

                    <v-btn class="botonUse2" elevation="0" @click="returnPage(2)">
                        Atención al cliente
                    </v-btn>

                    </div>

                </div>

                <div v-else style="background-color: #E3E9FD; min-height: 150px;">

                    <div style="max-width: 250px; margin: auto;">

                    <label class="text-center subLabelSub">¿Quieres ver otros seguros? Conócelos en nuestro sitio web. </label>

                    <br>
                    <br>

                    <v-btn class="botonUse2" elevation="0" @click="returnPage(1)">
                        Volver al inicio
                    </v-btn>

                    </div>

                    <br>
                    <br>

                    <div style="max-width: 250px; margin: auto;">

                    <label class="text-center subLabelSub">Si tienes problemas, comunícate con nosotros aquí: </label>

                    <br>
                    <br>

                    <v-btn class="botonUse2" elevation="0" @click="returnPage(2)">
                        Atención al cliente
                    </v-btn>

                    </div>

                </div>

                <br>

                </div>

                <div style="background-color: #2A3881;">

                <br>

                <v-img contain max-height="70px" :src="LogoSB2" max-width="150" style=" margin: auto; " />

                <br>

                </div>

            </div>

    </v-container>
</template>

<script>
import Titulo from "../components/Titulo.vue"
// import NavBar from "@/components/NavBar.vue";

import ShieldService from "../services/shield.service";
// import swal from 'sweetalert';
import CryptoJS from 'crypto-js'
import LogoSB2 from "@/assets/images/LogoFooter33.svg";

export default {
    components: { Titulo },
    // components: { Titulo, NavBar },
    data() {
        return {
            LogoSB2,
            secretKey: process.env.VUE_APP_CRYPT,
            success: null,
            load: false,
            screen: window.screen.width,
            planData: null,
            userData: {
                name: null,
                email: null,
            },
            servicesData: null,
            activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
        }
    },
    methods: {
        capitalizeName(name) {
            if (!name) return '';
            return name.charAt(0).toUpperCase() + name.slice(1);
        },
        returnPage(index) {
            sessionStorage.removeItem('userData');
            sessionStorage.removeItem('benefData');
            sessionStorage.removeItem('servicesData');
            sessionStorage.removeItem('planData');

            if(index == '0'){
                this.$router.push({ path: '/og/inicio' })
            } else if (index == '1') {
                window.location.href = 'https://southbridgeseguros.cl/';
            } else if (index == '2') {
                window.location.href = 'https://southbridgeseguros.cl/contacto';
            } 
            
        }
    },
    async mounted() {
        const query = this.$route.query;
        if (query) {
            if (query.success === "true") {

                const userDataAux = sessionStorage.getItem('userData');
                const planDataAux = sessionStorage.getItem('planData');
                const servicesDataAux = sessionStorage.getItem('servicesData');

                if (userDataAux) {
                    const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
                    const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
                    this.userData = JSON.parse(decryptedDataUser);
                    // console.log("userData: ", this.userData);
                }

                if (servicesDataAux) {
                    const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
                    const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
                    this.servicesData = JSON.parse(decryptedServicesData);
                    // console.log("servicesData: ", this.servicesData);
                }

                if (planDataAux) {
                    const bytesPlanData = CryptoJS.AES.decrypt(planDataAux, this.secretKey);
                    const decryptedDataPlan = bytesPlanData.toString(CryptoJS.enc.Utf8);
                    this.planData = JSON.parse(decryptedDataPlan).plan;
                    // console.log("planData: ", this.planData);
                }

                this.success = true;

                if (this.activeCampaingUse == 'TRUE') {
                    await ShieldService.updateContactActiveCampain(null, this.planData, this.servicesData, 3);
                }

                // swal({
                //     title: "¡Has contratado tu seguro con éxito! ",
                //     text: "Revisa tu correo electrónico para obtener toda la información.",
                //     icon: "success",
                //     button: "Revisar detalle",
                // });

                this.load = true

            } else if (query.success === "false") {
                this.success = false;
            }
        }
    },

}
</script>

<style>
.v-alert {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translate(-50%, 100%);
    margin: 0 auto;
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.row div.text-center.col div.mx-auto.v-card.v-sheet.theme--light.elevation-2 div.text-center.col {
    margin: auto;
}

.subLabel {
    color: var(--Primario---Azul-claro, #4F74E3);
    text-align: center;
    font-family: Helvetica;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
}

.botonUse {
    display: flex;
    width: 241px;
    height: 52px;
    padding: 10px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 40px;
    background: var(--Celeste-SB, #4F74E3) !important;
    color: white !important;
    margin: auto;
}

.subLabelSub {
    color: var(--AD-Texto-1, #333);
    text-align: center;
    font-family: Helvetica;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
}

/* footer */
.cobertura {
  font-family: Helvetica;
  font-style: normal;
  text-align: center;
  font-size: 15px;
  font-weight: 550;
  color: #232323;
  line-height: 16px;
  opacity: 0.75;
}

@media only screen and (max-width: 767px) {
  .cobertura {
    font-family: Helvetica;
    font-style: normal;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #232323;
    line-height: 13px;
    opacity: 0.75;
  }
}

.footer {
  height: 67px;
}

.botonUse2 {
  display: flex;
  width: 241px;
  height: 52px;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 40px;
  background: var(--Celeste-SB, #2A3881) !important;
  color: white !important;
  margin: auto;
}

.subLabelSub {
  color: var(--AD-Texto-1, #333);
  text-align: center;
  font-family: Helvetica;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
}


.footerFinish {
    width: 113%;
    margin-left: -7%;
    margin-top: 8px;
    margin-bottom: -7%;
}
</style>